import React from "react";
import { useShoppingContext } from "../context/ShoppingContext";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faMinus,
  faPlus,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import "./Buscar.css";
import AddAlimentoForm from "../Granja/Add/Forms/AddAlimentoForm/AddAlimentoForm";
import AddGranjaForm from "../Granja/Add/Forms/AddFarmForm/AddGranjaForm";
import AddAveForm from "../Granja/Add/Forms/AddBatchForm/AddAveForm";
import AddGalponForm from "../Granja/Add/Forms/AddGalponForm/AddGalponForm";

const Buscar = () => {
  const navigate = useNavigate();
  const {
    query, setQuery,
    aves,
    alimentos,
    galpones,
    granjas,
    getAveNombre,
    getAlimentoNombre,
    getGalponNombre,
    getGranjaNombre,
    showAddAlimento,
    setShowAddAlimento,
    showAddAves,
    setShowAddAves,
    showAddGalpon,
    setShowAddGalpon,
    showAddGranja,
    setShowAddGranja,
    renderDateTitle,
    isDarkMode,
  } = useShoppingContext();

  // Función de búsqueda
  const handleSearch = (e) => {
    setQuery(e.target.value.toLowerCase());
  };

  // Función para borrar el campo de búsqueda
  const clearSearch = () => {
    setQuery("");
  };

  // Función para actualizar el campo de búsqueda con el nombre del ítem seleccionado
  const fillSearchField = (name) => {
    setQuery(name.toLowerCase());
  };

  // Filtra los resultados basados en el término de búsqueda
  const filteredAves = aves.filter((ave) =>
    getAveNombre(ave.id).toLowerCase().includes(query)
  );
  const filteredAlimentos = alimentos.filter((alimento) =>
    getAlimentoNombre(alimento.id).toLowerCase().includes(query)
  );
  const filteredGalpones = galpones.filter((galpon) =>
    getGalponNombre(galpon.id).toLowerCase().includes(query)
  );
  const filteredGranjas = granjas.filter((granja) =>
    getGranjaNombre(granja.id).toLowerCase().includes(query)
  );

  // Función para agregar nuevos elementos
  const handleAdd = (type) => {
    switch (type) {
      case "ave":
        setShowAddAves(!showAddAves);
        break;
      case "alimento":
        setShowAddAlimento(!showAddAlimento);
        break;
      case "galpon":
        setShowAddGalpon(!showAddGalpon);
        break;
      case "granja":
        setShowAddGranja(!showAddGranja);
        break;
      default:
        break;
    }
  };

  // Función para mostrar la tabla si solo hay un resultado
  const showDetailsTable = () => {
    const totalResults =
      filteredAves.length +
      filteredAlimentos.length +
      filteredGalpones.length +
      filteredGranjas.length;
    if (totalResults === 1) {
      if (filteredAves.length === 1) {
        return (
          <>
            {renderFilteredAves()} {renderDetailsCard(filteredAves[0], "ave")}
            {/* Muestra todos los resultados filtrados aquí */}
          </>
        );
      } else if (filteredAlimentos.length === 1) {
        return (
          <>
            {renderFilteredAlimentos()} {/* Muestra los alimentos filtrados */}
            {renderDetailsCard(filteredAlimentos[0], "alimento")}
          </>
        );
      } else if (filteredGalpones.length === 1) {
        return (
          <>
            {renderFilteredGalpones()} {/* Muestra los galpones filtrados */}
            {renderDetailsCard(filteredGalpones[0], "galpon")}
          </>
        );
      } else if (filteredGranjas.length === 1) {
        return (
          <>
            {renderFilteredGranjas()} {/* Muestra las granjas filtradas */}
            {renderDetailsCard(filteredGranjas[0], "granja")}
          </>
        );
      }
    }
    return null;
  };

  // Función para renderizar la tabla de detalles
  const renderDetailsCard = (item, type) => {
    switch (type) {
      case "ave":
        return (
          <div className="details-card">
            <h3 className="card-title">Detalles del Ave</h3>
            <div className="card-content">
              <div className="card-row">
                <span className="card-label">Especie:</span>
                <span className="card-value">{item.especie}</span>
              </div>
              <div className="card-row">
                <span className="card-label">Nombre:</span>
                <span className="card-value">{item.nombre}</span>
              </div>
              <div className="card-row">
                <span className="card-label">Fecha de Recepción:</span>
                <span className="card-value">
                  {renderDateTitle(item.fecha_recepcion)}
                </span>
              </div>
              <div className="card-row">
                <span className="card-label">Cantidad Inicial:</span>
                <span className="card-value">{item.cantidad_inicial} aves</span>
              </div>
              <div className="card-row">
                <span className="card-label">Edad de Llegada:</span>
                <span className="card-value">{item.edad_llegada} semanas</span>
              </div>
              <div className="card-row">
                <span className="card-label">Edad Actual:</span>
                <span className="card-value">{item.edad_actual} semanas</span>
              </div>
              <div className="card-row">
                <span className="card-label">Saldo:</span>
                <span className="card-value">{item.saldo} aves</span>
              </div>
              <div className="card-row">
                <span className="card-label">Ingesta Diaria:</span>
                <span className="card-value">{item.ingesta_diaria} gr. / ave</span>
              </div>
              <div className="card-row">
                <span className="card-label">Aves perdidas:</span>
                <span className="card-value">{item.mortalidad}</span>
              </div>
              <div className="card-row">
                <span className="card-label">Galpón:</span>
                <span className="card-value">
                  {getGalponNombre(item.galponId)}
                </span>
              </div>
              <div className="card-row">
                <span className="card-label">Granja:</span>
                <span className="card-value">
                  {getGranjaNombre(item.granjaId)}
                </span>
              </div>
            </div>
          </div>
        );
      case "alimento":
        return (
          <div className="details-card">
            <h3 className="card-title">Detalles del Alimento</h3>
            <div className="card-content">
              <div className="card-row">
                <span className="card-label">Nombre:</span>
                <span className="card-value">{item.nombre}</span>
              </div>
              <div className="card-row">
                <span className="card-label">Cantidad:</span>
                <span className="card-value">{item.cantidad} kg</span>
              </div>
              <div className="card-row">
                <span className="card-label">Peso Saco:</span>
                <span className="card-value">{item.pesoSaco} kg</span>
              </div>
            </div>
          </div>
        );
      case "galpon":
        return (
          <div className="details-card">
            <h3 className="card-title">Detalles del Galpón</h3>
            <div className="card-content">
              <div className="card-row">
                <span className="card-label">Nombre:</span>
                <span className="card-value">{item.nombre}</span>
              </div>
              <div className="card-row">
                <span className="card-label">Largo:</span>
                <span className="card-value">{item.largo} m</span>
              </div>
              <div className="card-row">
                <span className="card-label">Ancho:</span>
                <span className="card-value">{item.ancho} m</span>
              </div>
              <div className="card-row">
                <span className="card-label">Granja:</span>
                <span className="card-value">{getGranjaNombre(item.granjaId)}</span>
              </div>
            </div>
          </div>
        );
      case "granja":
        return (
          <div className="details-card">
            <h3 className="card-title">Detalles de la Granja</h3>
            <div className="card-content">
              <div className="card-row">
                <span className="card-label">Nombre:</span>
                <span className="card-value">{item.nombre}</span>
              </div>
              <div className="card-row">
                <span className="card-label">Ubicación:</span>
                <span className="card-value">{item.ubicacion}</span>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  // Renderiza los resultados filtrados de aves debajo de la tabla de detalles
  const renderFilteredAves = () => {
    return filteredAves.map((ave) => (
      <div key={ave.id} className="buscar-item">
        <span
          className="item-name"
          onClick={() => fillSearchField(getAveNombre(ave.id))}
        >
          {getAveNombre(ave.id)}
        </span>
        <button onClick={() => navigate(`/edit-ave/${ave.id}`)}>
          Editar <FontAwesomeIcon icon={faEdit} />
        </button>
      </div>
    ));
  };

  // Renderiza los resultados filtrados de alimentos
  const renderFilteredAlimentos = () => {
    return filteredAlimentos.map((alimento) => (
      <div key={alimento.id} className="buscar-item">
        <span
          className="item-name"
          onClick={() => fillSearchField(getAlimentoNombre(alimento.id))}
        >
          {getAlimentoNombre(alimento.id)}
        </span>
        <button onClick={() => navigate(`/edit-alimento/${alimento.id}`)}>
          Editar <FontAwesomeIcon icon={faEdit} />
        </button>
      </div>
    ));
  };

  // Renderiza los resultados filtrados de galpones
  const renderFilteredGalpones = () => {
    return filteredGalpones.map((galpon) => (
      <div key={galpon.id} className="buscar-item">
        <span
          className="item-name"
          onClick={() => fillSearchField(getGalponNombre(galpon.id))}
        >
          {getGalponNombre(galpon.id)}
        </span>
        <button onClick={() => navigate(`/edit-galpon/${galpon.id}`)}>
          Editar <FontAwesomeIcon icon={faEdit} />
        </button>
      </div>
    ));
  };

  // Renderiza los resultados filtrados de granjas
  const renderFilteredGranjas = () => {
    return filteredGranjas.map((granja) => (
      <div key={granja.id} className="buscar-item">
        <span
          className="item-name"
          onClick={() => fillSearchField(getGranjaNombre(granja.id))}
        >
          {getGranjaNombre(granja.id)}
        </span>
        <button onClick={() => navigate(`/edit-granja/${granja.id}`)}>
          Editar <FontAwesomeIcon icon={faEdit} />
        </button>
      </div>
    ));
  };

  return (
    <div className={isDarkMode ? "content-container" : "content-container light"}>
      <div className={isDarkMode ? "buscar-container" : "buscar-container light"}>
        <div className="search-wrapper">
          <input
            type="text"
            placeholder="Buscar..."
            value={query}
            onChange={handleSearch}
            className="buscar-input"
          />
          {query && (
            <FontAwesomeIcon
              icon={faTimes}
              onClick={clearSearch}
              className="clear-icon"
            />
          )}
        </div>

        {/* Mostrar tabla de detalles si solo hay un resultado */}
        {showDetailsTable() || (
          <div className="buscar-results">
            <div className="buscar-header">
              <h3>Aves</h3>
              <FontAwesomeIcon
                icon={faPlus}
                onClick={() => handleAdd("ave")}
                className="add-icon"
              />
            </div>
            {filteredAves.length > 0 ? (
              filteredAves.map((ave) => (
                <div key={ave.id} className="buscar-item">
                  <span
                    className="item-name"
                    onClick={() => fillSearchField(getAveNombre(ave.id))}
                  >
                    {getAveNombre(ave.id)}
                  </span>
                  <button onClick={() => navigate(`/edit-ave/${ave.id}`)}>
                    Editar <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              ))
            ) : (
              <p>No se encontraron aves</p>
            )}

            <div className="buscar-header">
              <h3>Alimentos</h3>

              <FontAwesomeIcon
                icon={!showAddAlimento ? faPlus : faMinus}
                onClick={() => handleAdd("alimento")}
                className="add-icon"
              />
            </div>

            {showAddAlimento && <AddAlimentoForm />}
            {filteredAlimentos.length > 0 ? (
              filteredAlimentos.map((alimento) => (
                <div key={alimento.id} className="buscar-item">
                  <span
                    className="item-name"
                    onClick={() =>
                      fillSearchField(getAlimentoNombre(alimento.id))
                    }
                  >
                    {getAlimentoNombre(alimento.id)}
                  </span>
                  <button
                    onClick={() => navigate(`/edit-alimento/${alimento.id}`)}
                  >
                    Editar <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              ))
            ) : (
              <p>No se encontraron alimentos</p>
            )}

            <div className="buscar-header">
              <h3>Galpones</h3>
              <FontAwesomeIcon
                icon={faPlus}
                onClick={() => handleAdd("galpon")}
                className="add-icon"
              />
            </div>
            {filteredGalpones.length > 0 ? (
              filteredGalpones.map((galpon) => (
                <div key={galpon.id} className="buscar-item">
                  <span
                    className="item-name"
                    onClick={() => fillSearchField(getGalponNombre(galpon.id))}
                  >
                    {getGalponNombre(galpon.id)}
                  </span>
                  <button onClick={() => navigate(`/edit-galpon/${galpon.id}`)}>
                    Editar <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              ))
            ) : (
              <p>No se encontraron galpones</p>
            )}

            <div className="buscar-header">
              <h3>Granjas</h3>
              <FontAwesomeIcon
                icon={faPlus}
                onClick={() => handleAdd("granja")}
                className="add-icon"
              />
            </div>
            {filteredGranjas.length > 0 ? (
              filteredGranjas.map((granja) => (
                <div key={granja.id} className="buscar-item">
                  <span
                    className="item-name"
                    onClick={() => fillSearchField(getGranjaNombre(granja.id))}
                  >
                    {getGranjaNombre(granja.id)}
                  </span>
                  <button onClick={() => navigate(`/edit-granja/${granja.id}`)}>
                    Editar <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              ))
            ) : (
              <p>No se encontraron granjas</p>
            )}
          </div>
        )}
        {showAddGranja && <AddGranjaForm />}
        {showAddAves && <AddAveForm />}
        {showAddGalpon && <AddGalponForm />}
      </div>
    </div>
  );
};

export default Buscar;
